<template>
    <f-dialog
        :title       = "$t('img.folder.create.title')"
        v-model      = "show"
        :width       = "460"
        :store-label = "$t('img.folder.create.store')"
        :show-save   = "valid && !running"
        @cancel      = "onCancel"
        @store       = "onSave"
    >
        <template v-slot:content>
            <v-row dense>
                <v-col>
                    <v-text-field
                        :label       = "$t('img.folder.create.name')"
                        v-model      = "name"
                        counter      = "100"
                        maxlength    = "100"
                        autocomplete = "off"
                        autofocus
                        @keyup.enter = "onSave"
                    />
                </v-col>
            </v-row>
        </template>
    </f-dialog>
</template>

<script>

import FDialog from "@/modules/core/components/utils/FDialog.vue";
import Img from "@/modules/img/components/service/Img";

export default {
    name: "DImageFolderCreate",

    components: {
        FDialog
    },

    props: {
        value: {

        },

        site: {

        }
    },

    data: () => ({
        show: false,
        name: "",
        running: false,
    }),

    computed: {
        valid () {
            return this.name.trim().length > 0 && this.name.length <= 100;
        }
    },

    watch: {
        value () {
            this.show = this.value;
            if (this.show) {
                this.name = "";
                this.running = false;
            }
        }
    },

    mounted () {
        this.show = this.value;
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        onSave () {
            if (!this.valid || this.running) {
                return;
            }

            this.running = true;
            Img.createFolder(this.site.id, this.name.trim())
                .then(folder => {
                    this.$emit("created", folder);
                    this.$emit("input", false);
                })
                .catch(() => {
                    // the error is shown by the request
                })
                .finally(() => {
                    this.running = false;
                });
        }
    }
}
</script>
